import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExpressionRule } from "../../ExpressionRule";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class RandomExpression extends ExpressionRule {
    readonly __type: string = "Random";

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();
    }

    // eslint-disable-next-line
    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return Math.random();
    }
}
